import { useCallback, useEffect, useState } from 'react';
import { getCellValue } from '../../../utils';
export const useColumnAndCellSelection = (props) => {
    const { value, onCellSelected, column, selectedCell, highlightSelectedColumn, } = props;
    const [isCellSelected, setCellSelected] = useState(false);
    const [selectFullColumn, setSelectFullColumn] = useState(false);
    useEffect(() => {
        if (selectedCell) {
            if (highlightSelectedColumn)
                setSelectFullColumn(selectedCell.columnName === column.name);
            if (!highlightSelectedColumn &&
                selectedCell.cellValue === value &&
                selectedCell.columnName === column.name)
                setCellSelected(true);
        }
    }, [column.name, highlightSelectedColumn, selectedCell, value]);
    const onSelection = useCallback(() => {
        if (onCellSelected) {
            setCellSelected(!isCellSelected);
            onCellSelected({
                columnName: column.name,
                cellValue: getCellValue(value),
            });
        }
    }, [column.name, isCellSelected, onCellSelected, value]);
    return { isCellSelected, selectFullColumn, onSelection };
};
//# sourceMappingURL=index.js.map